<template>
    <div class="home_header" id="header">
        <div class="logo"  id="moveTo"></div>
        <div class="nav">
            <ul class="myMenu tm">
                <li><a data-menuanchor="firstPage" class="menu" >COMPANY </a></li>
                <li><a data-menuanchor="secondPage" class="menu" >SERVICE </a></li>
                <li><a data-menuanchor="thirdPage" class="menu" >WORK </a></li>
                <li><a data-menuanchor="fourthPage" class="menu" >CONTACT </a></li>
            </ul>
        </div>

<!--        <div class="leftMenu">-->
<!--            <ul class="myMenu lm" id="btm">-->
<!--                <li data-menuanchor="firstPage"><a data-menuanchor="firstPage"  class="menu ">01</a>-->
<!--                </li>-->
<!--                <li data-menuanchor="secondPage"><a data-menuanchor="secondPage" class="menu">02</a></li>-->
<!--                <li data-menuanchor="thirdPage"><a data-menuanchor="thirdPage"  class="menu">03</a>-->
<!--                </li>-->
<!--                <li data-menuanchor="fourthPage"><a data-menuanchor="fourthPage" class="menu">04</a></li>-->
<!--            </ul>-->
<!--        </div>-->
    </div>
</template>
<script>
    export default {
        name: 'PageHeader',
        mixins: [ ],
        components: {
        },
        computed: {
        },
        created() {
        },
        data() {
            return {

            }
        },
        mounted() {
        },
        methods: {
        },
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
